import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import {
  onDesktopOnly as onDesktopOnlyStyles,
  onMobileOnly as onMobileOnlyStyles,
} from "./styles.module.scss"

const LineBreak = ({ onDesktopOnly, onMobileOnly }) => (
  <br
    className={classNames({
      [onDesktopOnlyStyles]: onDesktopOnly,
      [onMobileOnlyStyles]: onMobileOnly,
    })}
  />
)

LineBreak.propTypes = {
  onDesktopOnly: PropTypes.bool,
  onMobileOnly: PropTypes.bool,
}

LineBreak.defaultProps = {
  onDesktopOnly: false,
  onMobileOnly: false,
}

export default LineBreak
